import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { GlobalState } from 'store/rootReducer';

export const useNlSelector: TypedUseSelectorHook<GlobalState> = useSelector;
